import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";
import { cn } from "@dosa/ui";

export function LanguageSwitch({ className }: { className?: string }) {
  const { i18n, t } = useTranslation();
  const next = i18n.language === "ar" ? "en" : "ar";

  return (
    <button
      type="button"
      onClick={() => i18n.changeLanguage(next)}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-sm font-medium text-charcoal-700 hover:bg-ivory-muted",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
        className,
      )}
      aria-label={t("common.language")}
    >
      <Languages className="h-4 w-4" aria-hidden="true" />
      {next === "ar" ? t("common.arabic") : t("common.english")}
    </button>
  );
}
